import iccService from '../icc/iccService';
import authDataStoreService from './authDataStoreService';

const getAuthToken = async (isRetry) => {
    try {
        const {accessToken} = authDataStoreService.getAccessTokenData();

        if (accessToken) {
            return accessToken;
        }

        if (!isRetry) {
            await iccService.fetchIccToken();
            return await getAuthToken(true);
        }
    } catch (e) {
        return Promise.reject(`getAuthToken error: ${e}`);
    }

    return Promise.reject(`getAuthToken error: return undefined`);
};

export default {
    getAuthToken,
};
